import { CircularProgress, MenuItem, Pagination, Select, TextField } from "@mui/material"
import { useState,useEffect, Fragment, useContext } from "react"
import DownloadIcon from '../../assets/iposub/downloadArrow.svg'
import './SummaryPages.css'
import BackIcon from '../../assets/Demat/back_icn_btn.svg'
import CloseIcon from '../../assets/closeMenu.svg'
import CalendarIcon from '../../assets/DashBoard/calendar_icon.svg'

import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from "@mui/lab"
import { Context } from "../../services/apiContext"
import { getClientIp } from "../../helperFunctions/helperFunctions"

export default function SummaryTable({referral_id,type:tableType,...props}){
    const MIN_DATE = `2022-02-01`
    const columnMap = {
        name:{label:"Name"},
        broker:{label:"Broker Name"},
        
        dateStr:{label:"Date & Time"},

        status:{label:"Status"},
        earnings:{label:"Earnings (₹)"},

    }
    const tableColumns  = Object.keys(columnMap).map(k => ({...columnMap[k],key:k}))


    const frDate = MIN_DATE
    // const toDate = `2022-04-01`
    const toDate = getDateInKebab(new Date())

    const ALL = 'all'
    const ONLY_OPENED = 'only_opened'
    const defaultFilter = tableType == 2 ? ALL : ONLY_OPENED

    const [statusFilter,setStatusFilter] = useState(defaultFilter) 
    const options = [
        { name: 'All', value: defaultFilter },
        { name: 'Account Opened', value: ONLY_OPENED },
        // { name: 'Rejected', value: 'rejected' }
    ]

    const [tableData,setTableData] = useState([])
    const [filteredData,setFilteredData] = useState(tableData)

    const [downloadLink,setDownloadLink] =  useState('')
    const [loading,setLoading] = useState(false)
    const [page,setPage] = useState(1)
    
    const switchToPage = (page) => {
        
    }
    
    const [startDate,setStartDate] = useState(frDate)
    const [endDate,setEndDate] = useState(toDate)
    const [previousFilters,setPreviousFilters] = useState({startDate,endDate,statusFilter})
    
    const contextapi = useContext(Context);

    async function fetchTableData(){

        const user_ip =   await getClientIp()

        const url = '/referral/refearningDetails'

        const payload = {
            referral_id,
            user_ip,
            type: statusFilter == ONLY_OPENED ? 'O' : "L"
        }

        try {
            const res = await contextapi.postApiCalling(url, payload,{noSpinner:true})
            // console.log(res);
            if (res.status_desc == "Success") {
             
            //   console.log(res,res.details)
              const tdata = res.details
              return tdata 
              // console.log(res.msg);
              // console.log(dashboardDetails);
            }else{
                alert(res.status_desc)
            }

            return []
            // const mockItem = {
            //     "name": "Ajay kumar yadav",
            //     "broker": "Bajaj Finserv",
            //     "date": "Mar 1 2022 2:11PM",
            //     "status": "Account Opened",
            //     "earnings": "275"
            // }
            // const mockData= (new Array(13)).fill(mockItem)
            // return mockData

        } catch (error) {
            console.error(error);
            alert('Error fetching referral data')
            // setNotifi({ val: true, msg: "Something went wrong" });
            return []
        }
    }

 

    function prepareDownloadLink(tableData){

        if (tableData.length > 0) {
            const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
            const keys = tableColumns.map(c=>c.key);
            const header = tableColumns.map(c=>c.label);
            const csv = [
            header.join(","), // header row first
            ...tableData.map((row) =>
                keys
                .map((key) => JSON.stringify(row[key], replacer))
                .join(",")
            ),
            ].join("\r\n");
            var csvFile = new Blob(["\uFEFF" + csv], {
            type: "text/csv; charset=utf-18",
            });
            const link = URL.createObjectURL(csvFile);
    
            // const a = document.createElement('a')
            // a.href = downloadLink
    
            // document.appendChild(a)
            // a.click()
            // document.removeChild(a)
    
    
            setDownloadLink(link);
        } else {
            // alert("No Data to Download");
        }
    
    }


    async function fetchRecords(){

        try {
            setLoading(true)
            setPreviousFilters({startDate,endDate,statusFilter})
            await wait(500)

            const tableDataRaw = await fetchTableData()
            const newTableData = tableDataRaw.map(d => ({...d,dateStr:d.date,date:parseDate(d.date)})) 

            const filteredData = newTableData.filter(d => (d.date >= startDate) && (d.date <= endDate))

            setTableData(newTableData)
            setFilteredData(filteredData)


        } catch (error) {
            console.log(error)
        } finally{
            setLoading(false)
            
        }

    }
    function applyFilter(){
        fetchRecords() 
    }
    function resetFilter(){
        setStartDate(toDate)
        setStatusFilter(defaultFilter)
        fetchRecords() 
    }
    const isFiltering = (statusFilter != defaultFilter || startDate != toDate)

    useEffect(()=>{
        if(referral_id){
            fetchRecords({})
        }

    },[referral_id])

    useEffect(()=>{
        prepareDownloadLink(filteredData.map(d=>{
            const nd = {...d}
            delete nd.date
            return nd
        }))
    },[filteredData])

    const renderInput= (params) => <TextField {...params} size={"small"} 
                sx={{ width: 180,margin: "0px 12px" }}
            />
    const page_size = 10

    const page_start = Math.max(page-1,0)*page_size
    const page_end = page_start+page_size

    // console.log(`showing from ${page_start} to ${page_end}`)
    // console.log(startDate,endDate)
    // const filteredData = tableData.filter(d => (d.date > startDate) && (d.date < endDate))

    const currentPageEntries = filteredData.slice(page_start,page_end)

    const OpenPickerIcon = ()=> <img src={CalendarIcon} style={{width:'24px'}} />

    const totalPageCount = (Math.ceil(tableData.length / page_size))

    const handleDateChange = (setter) => (e) => {
        const value = new Date(e)

        setter(getDateInKebab(value))
    } 

    const filtersChanged = (startDate != previousFilters.startDate) || (endDate != previousFilters.endDate) || (statusFilter != previousFilters.statusFilter)

    return <div className="py-2 ">
        <div className="d-flex mx-4 my-2 align-items-center">
            <Select value={statusFilter} onChange={e=>setStatusFilter(e.target.value)}
                size="small"
                // label="-"
                // variant={"outlined"}
                title={''}
                style={{width:'170px'}}
            >
                {options.map(o => 
                    <MenuItem value={o.value} key={o.name}>
                            {o.name}
                    </MenuItem>  
                )}
            </Select>
                    
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
            >

                <DesktopDatePicker
                    // label="Date desktop"
                    inputFormat="dd/MM/yyyy"
     
                    value={startDate}
                    onChange={handleDateChange(setStartDate)}
                    components={{OpenPickerIcon}}

                    maxDate={new Date(endDate)}
                    minDate={new Date(MIN_DATE)}
                    disableFuture

                    renderInput={renderInput}
                />
                <p className="m-0 ">
                    To
                </p>

                <DesktopDatePicker
                    // label="Date desktop"
                    inputFormat="dd/MM/yyyy"
                    
                    // minDate={startDate}
                    minDate={new Date(startDate)}
                    disableFuture

                    value={endDate}
                    onChange={handleDateChange(setEndDate)}
                    components={{OpenPickerIcon}}

                    renderInput={renderInput}
                />
                
            </LocalizationProvider>

{/* 
            <TextField
                id="start-date"
                // label="From"
                type="date"
                variant="outlined"
                defaultValue="2022-05-24"
                sx={{ width: 180,margin: "0px 16px" }}
                InputLabelProps={{shrink: true,}}
                size="small"

                value={startDate}
                onChange={e=>setStartDate(e.target.value)}
            /> */}

            {/* <p className="m-0 ms-3">
                To
            </p>
                
            <TextField
                id="end-date"
                // label="To"
                type="date"
                variant="outlined"
                defaultValue="2022-05-24"
                sx={{ width: 180,margin: "0px 16px" }}
                InputLabelProps={{shrink: true,}}
                size="small"

                value={endDate}
                onChange={e=>setEndDate(e.target.value)}
            /> */}

            <button className=" bg-transparent border-pri  text-md text-pri
             text-uppercase px-4 p-2 rounded cursor-pointer "   
                onClick={applyFilter}
                disabled={!filtersChanged}
                style={{fontWeight:500,border:'1px solid',opacity:filtersChanged?'1':'0.4'}}
            >
                Apply
            </button>

            {/* {!!isFiltering && 
                <button className="ms-2 bg-transparent  text-md text-uppercase px-3 p-2 rounded
                    cursor-pointer border-secondary text-secondary
                "   onClick={resetFilter}
                    style={{fontWeight:500,border:'1px solid'}}
                >
                    <img src={CloseIcon}  />
                </button>
            } */}

            <a href={downloadLink} download={"Referral Earning Report.csv"}
                className={`ms-auto `}
            >

                <button className=" bg-pri border-0 text-white px-4 p-2 rounded text-uppercase text-md"
                    style={{fontWeight:500}}
                >
                    <img src={DownloadIcon} style={{width:'20px',height:'20px',marginRight:'12px'}} />
                    Download
                </button>
            </a>
        </div>

        <div className="p-4 ">
            <div className="position-relative overflow-hidden rounded border mb-3">

                <ActualTable 
                    tableData={currentPageEntries}
                    loading={loading}
                    tableColumns={tableColumns}
                />     
                
                {!!loading &&
                    <div className="w-100 h-100 position-absolute bg-white d-flex justify-content-center align-items-center " 
                    style={{opacity:'0.8',zIndex:2,left:'0',top:'0',minHeight:'200px'}}>
                        <CircularProgress />
                    </div>
                }
            </div>
            <Pagination count={totalPageCount} variant="outlined" shape="rounded" 
                color="primary"
                page={page}
                onChange={(e,new_page)=>{
                    setPage(new_page)
                }}
            />   
        </div>



    </div>
}



function ActualTable({tableColumns,tableData,loading}){



    return  <Fragment>

        <table className="table1 w-100 mb-0 ">

        <thead>
            <tr>
                {tableColumns.map(col => 
                    <th className="text-start text-uppercase">{col.label}</th>
                )}
            </tr>
        </thead>
        <tbody>
            {
                tableData.map((item, i) => (
                    <tr key={i}>
                        {
                            tableColumns.map(col => 
                                <td key={col.key}  className="text-start  py-3">
                                    {item[col.key]}
                                </td>    
                            )
                        }
                    </tr>
                ))
            }
        </tbody>


    </table>
    {tableData.length === 0 && (
        <div className="norecords w-100" >
            {!loading
                &&
                <p className="text-sm text-muted" style={{fontSize:'0.9em'}}>
                    No Records Found
                </p>
            }
        </div>
    )}
    </Fragment>
}



async function wait(timeout){

    return new Promise((res,rej)=>{
  
      setTimeout(() => {
        res()
      }, timeout);
    })
  }


  export const BackButton =   ({onClick}) =>
    <button className='border-1 text-pri border-pri rounded p-1 px-3
  bg-transparent text-md' style={{fontWeight:'500'}}
   onClick={()=>onClick()}
 >
   <img src={BackIcon} 
     style={{width:'16px',height:'16px',marginRight:'12px'}}
   />
   BACK
 </button>


export function padZeroes(num,zeroes=1){
    return (('0'.repeat(zeroes))+num).slice(-1-zeroes)
}

// sample input: "Mar 1 2022 3:36AM"
function parseDate(crazyDate){
    const parts = crazyDate.split(' ')
    const [monthStr,date,fullYear] = parts

    const months = `Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec`.split(',')
    const month = months.findIndex(a=>a==monthStr) 

    return `${fullYear}-${padZeroes(month+1)}-${padZeroes(date)}` 
}

function getDateInKebab(date){
    return `${date.getFullYear()}-${padZeroes(date.getMonth()+1)}-${padZeroes(date.getDate())}`

}